import React, { useState }  from 'react';
import { Link as LinkRoute } from 'react-router-dom';
import { signInUser } from '../../services/sign_in_service';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { ErrorMessage } from '@hookform/error-message';
import {
	Avatar,
    Typography,
	Button,
	CssBaseline,
	TextField,
	FormControlLabel,
	Checkbox,
	// Link,
	Grid,
	Box,
	Container
} from '@material-ui/core';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import { makeStyles } from '@material-ui/core/styles';
import Copyright from '../copyright/copyright';
import { REACT_ROUTES } from '../../constants/react_routes';

const useStyles = makeStyles((theme) => ({
	paper: {
		marginTop: theme.spacing(8),
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center'
	},
	avatar: {
		margin: theme.spacing(1),
		backgroundColor: theme.palette.secondary.main
	},
	form: {
		width: '100%', // Fix IE 11 issue.
		marginTop: theme.spacing(1),
        '& > p': {
            color: '#bf1650',
            '&::before': {
                display: 'inline',
                content: '"⚠ "'
            }
        }
	},
	submit: {
		margin: theme.spacing(3, 0, 2)
	},
    link: {
        color: '#64b5f6',
        '&:hover': {
            color: '#53a3df'
        }
    }
}));

const SignIn = () => {
	const { paper, avatar, form, submit, link } = useStyles();
    const { register, handleSubmit, setError, formState: { errors } } = useForm();
    const dispatch = useDispatch();
	const [ showPassword, setShowPassword ] = useState(false);
	const handlePasswordVisibility = () => setShowPassword(!showPassword);

    const onSubmit = async (data) => {
        const { status } = await dispatch(signInUser(data));
        if (status === 401) {
            setError('email', {
                type: 'manual',
                message: 'Neispravni podaci'
            });
            setError('password', {
                type: 'manual',
                message: 'Neispravni podaci'
            });
        }
    };

	return (
		<Container component="main" maxWidth="xs">
			<CssBaseline />
			<Grid className={paper}>
				<Avatar className={avatar}>
					<LockOutlinedIcon />
				</Avatar>
				<Typography component="h1" variant="h5">
					Prijava
				</Typography>
				<form onSubmit={handleSubmit(onSubmit)} className={form}>
					<TextField
						variant="standard"
						margin="normal"
						required
						fullWidth
						name="email"
						label="Email"
						autoComplete="email"
						autoFocus
                        {...register("email", { required: true }) }
					/>
                    <ErrorMessage errors={errors} name="email" as="p" />
					<Box position="relative">
						<TextField
							variant="standard"
							margin="normal"
							required
							fullWidth
							name="password"
							label="Lozinka"
							type={showPassword ? "text" : "password"}
							autoComplete="current-password"
							{...register("password", { required: true }) }
						/>
						<ErrorMessage errors={errors} name="password" as="p" />
						<Box position="absolute" bottom="8px" right="8px" onClick={handlePasswordVisibility}>
							{showPassword ? <VisibilityIcon color="primary" cursor="pointer" /> : <VisibilityOffIcon color="primary" cursor="pointer" />}
						</Box>
					</Box>
					<FormControlLabel
						control={<Checkbox value="remember" color="primary" />}
						label="Zapamti me"
					/>
					<Button
						type="submit"
						fullWidth
						variant="contained"
						color="primary"
						className={submit}
					>
						Prijava
					</Button>
					<Grid container justify="center">
						{/* <Grid item xs>
							<Link href="#" variant="body2">
								Zaboravljena lozinka?
							</Link>
						</Grid> */}
						<Grid item>
							<LinkRoute className={link} to={REACT_ROUTES.SIGN_UP} variant="body2">
                                Nemate nalog? Registrujte se
							</LinkRoute>
						</Grid>
					</Grid>
				</form>
			</Grid>
			<Box mt={8}>
				<Copyright />
			</Box>
		</Container>
	);
}

export default SignIn;
